import React from "react";

interface SimpleTooltipContainer {
    onClick?: () => void
}


export const Container: React.FC<SimpleTooltipContainer> = React.forwardRef((props, ref: React.Ref<HTMLDivElement>) => {
    return (
        <div ref={ref} {...props}>
            {props.children}
        </div>
    );
});